<template>
    <div class="page">
        <el-scrollbar class="Yscrollbar" style="height: calc(45% - 8vh)">
            <LabelContent ref="LabelContent" title="基本信息"> </LabelContent>
            <el-form :inline="true" label-width="100px" class="arrange-form" size="small" style="text-align: left; height: 50px">
                <el-col :span="6">
                    <el-form-item label="所属工厂">
                        <el-input v-model="checkDetail.fcName" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备名称">
                        <el-input v-model="checkDetail.devName" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备编号">
                        <el-input v-model="checkDetail.devCode" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="班次日期">
                        <el-date-picker v-model="checkDetail.shiftDate" type="date" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="班次">
                        <el-input v-model="checkDetail.sfName" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备运行时长">
                        <el-input v-model="checkDetail.devRunTime" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备其他时间">
                        <el-input v-model="checkDetail.devOtherTime" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="开班点检人">
                        <el-input v-model="checkDetail.startUserName" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="开班点检时间">
                        <el-input v-model="checkDetail.shiftOfferStartTime" disabled />
                    </el-form-item>
                </el-col>
                <!--<el-col :span="6">
                    <el-form-item label="下班点检人">
                        <el-input v-model="checkDetail.endUserName" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="下班点检时间">
                        <el-date-picker v-model="checkDetail.shiftCloseEndTime" type="date" disabled />
                    </el-form-item>
                </el-col>-->
            </el-form>
        </el-scrollbar>

        <LabelContent title="设备点检详情" ref="LabelContent" />
        <el-form :inline="true" label-width="100px" class="arrange-form" size="small" style="text-align: left; height: 50px">
            <el-col :span="6">
                <el-form-item label="产品号">
                    <el-input v-model.trim="productCode"/>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item>
                    <el-button type="primary" @click="queryDaCkLog">查询</el-button>
                </el-form-item>
            </el-col>
        </el-form>
        <div class="tableBox">
            <el-table ref="multipleTable" stripe :data="logList" class="center" >
                <el-table-column prop="dciPart" label="点检部位" show-overflow-tooltip />
                <el-table-column prop="dciDesc" label="点检要求" show-overflow-tooltip />
                <el-table-column prop="ckType" sortable label="点检项" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.ckType == 'check_item'">检查项</span>
                        <span v-if="scope.row.ckType == 'clean_item'">清洁项</span>
                        <span v-if="scope.row.ckType == 'lubricate_item'">润滑项</span>
                    </template>
                </el-table-column>
                <el-table-column prop="productCode" label="产品号" show-overflow-tooltip/>
                <el-table-column prop="checkValType" sortable label="检测类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.checkValType == 'is_ok'">OK/NG类型</span>
                        <span v-if="scope.row.checkValType == 'number_type'">数字类型</span>
                        <span v-if="scope.row.checkValType == 'des_type'">描述类型</span>
                        <span v-if="scope.row.checkValType == 'pic_type'">图片类型</span>
                    </template>
                </el-table-column>
                <el-table-column prop="checkPic" sortable label="检测结果" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.checkValType == 'is_ok'">
                                <span>{{scope.row.isPass == true?'OK':'NG'}}</span>
                        </span>
                        <span v-if="scope.row.checkValType == 'number_type'">
                            <span>{{scope.row.checkDesc}}</span>
                        </span>
                        <span v-if="scope.row.checkValType == 'des_type'">
                            <span>{{scope.row.checkDesc}}</span>
                        </span>
                        <span v-if="scope.row.checkValType == 'pic_type'">
                            <div style="width: 10vw;" v-if="scope.row.checkPic.length != 0" v-for="pic in scope.row.checkPic">
                                <!-- <ul style="float: left;padding: 10px;">
                                <li>
                                    <el-popover placement="left" trigger="click" width="500">
                                        <el-image :src="pic" width="100%" :preview-src-list="scope.row.checkPic"/>
                                        <img slot="reference" :src="pic" :alt="pic" style="max-height: 50px;max-width: 50px; padding: 5px"/>
                                    </el-popover>
                                </li>
                            </ul> -->
                                <el-image :src="pic" :preview-src-list="scope.row.checkPic" @click.stop="handleClickStop"
                                    style="max-height: 50px;max-width: 50px; padding: 5px"/>
                            </div>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" sortable label="创建时间" show-overflow-tooltip/>
            </el-table>
        </div>
        <div
            class="bottomBtn"
            v-show="!checkDetail.dcoStatus || checkDetail.dcoStatus.code != 'pass'"
            >
            <el-button
                class="long"
                type="primary"
                size="small"
                @click="processData('pass')"
                v-show="showButton"
            >
                通过
            </el-button>
            <el-button
                class="long"
                type="info"
                size="small"
                @click="dialogDown = true"
            >
                拒绝
            </el-button>
        </div>
        <!-- 点击拒绝框 -->
        <el-dialog title="确认拒绝" :visible.sync="dialogDown" width="35%" center>
            <el-form ref="lvapForm" label-width="100px">
                <el-form-item label="审核意见:">
                    <el-input
                        v-model="checkDetail.dcoRemarks"
                        placeholder="请输入"
                        type="textarea"
                        :rows="3"
                        style="max-width: 100%; width: 100%"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" style="margin-top: 50px">
                <el-button @click="dialogDown = false">取 消</el-button>
                <el-button type="primary" @click="doFail()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'dailyCheckDetail',
    data() {
        return {
            logList: [],
            queryInfo: {
                page: 1,
                pageSize: 10,
                keyWords: '',
                orderCode: '',
                total:'',
            },
            productCode:'',
            docId: '',
            userList: [],
            orderList: [],
            tableHeight: 300,
            totalA: 0,
            checkDetail: {},
            dialogDown: false,
            showButton: true,
        }
    },
    created() {
        this.init()
    },
    mounted() {
      this.init()
    },
    methods: {
        handleClickStop() {
            this.$nextTick(() => {
                let domImageView = document.querySelector(".el-image-viewer__mask"); // 获取遮罩层dom
                if (!domImageView) {
                    return;
                }
                domImageView.addEventListener("click", () => {
                    // 点击遮罩层时调用关闭按钮的 click 事件
                    document.querySelector(".el-image-viewer__close").click();
                });
            });
        },
        doFail() {
            if (!this.checkDetail.dcoRemarks) {
                return this.$message.error("请填写不通过的原因");
            }
            this.processData('fail')
            this.sendMail()
        },
        processData(val) {
            if (val == 'pass') {
                this.checkDetail.dcoRemarks = '通过'
            }
            let params = {};
            params["dcoId"] = this.checkDetail.dcoId;
            params["dcoRemarks"] = this.checkDetail.dcoRemarks;
            params["dcoStatus"] = val;
            this.$http
                .request({
                url: "/api/daily_check_order/passDailyCheckOrder",
                method: "post",
                params: params,
                })
                .then((resp) => {
                if (resp.status == 100) {
                    this.$router.push({ name: 'dailyCheckOrder' })
                    return this.$message.success("操作成功");
                } else {
                    return this.$message.error(resp.message);
                }
                });
        },
        sendMail() {
            let params = {};
            params["dcoId"] = this.checkDetail.dcoId;
            params["dcoStatus"] = 'fail';
            this.$http
                .request({
                url: "/api/daily_check_order/sendMailDaily",
                method: "post",
                params: params,
                })
        },
        init(){
            if(this.$route.params.checkDetail != undefined && this.$route.query.checkDetail != ''){
                this.checkDetail = this.$route.params.checkDetail
                this.dcoId = this.$route.params.checkDetail.dcoId
                sessionStorage.setItem('dailyCheckDetail', JSON.stringify(this.checkDetail))
            }else{
                this.checkDetail = JSON.parse(sessionStorage.getItem('dailyCheckDetail'))
                this.dcoId = JSON.parse(sessionStorage.getItem('dailyCheckDetail')).dcoId
            }
            this.queryDaCkLog()
        },
        queryDaCkLog() {
            let queryParams = {
                dcoId: this.dcoId
            }
            if(this.productCode != undefined && this.productCode != ''){
                queryParams['productCode'] = this.productCode
            }
            let options = {
                method: 'GET',
                params: queryParams,
                url: this.$api.getDacklogDcoId
            }
            var self = this
            this.$http.request(options).then(response => {
                if(response.status == 100){
                    self.logList = []
                    var aa = response.data
                    if(aa != undefined && aa != '') {
                        for (let i = 0; i < aa.length; i++) {
                            if (aa[i].checkValType == 'is_ok' && !aa[i].isPass) {
                                self.showButton = false
                            }
                            var arr = {
                                dciPart: '',
                                dciDesc: '',
                                isPass: '',
                                ckType: '',
                                checkValType:'',
                                checkDesc:'',
                                checkPic: [],
                                createTime:'',
                                productCode:''
                            }
                            arr.dciPart = aa[i].dciPart
                            arr.dciDesc = aa[i].dciDesc
                            arr.isPass = aa[i].isPass
                            arr.ckType = aa[i].ckType
                            arr.checkValType = aa[i].checkValType
                            arr.checkDesc = aa[i].checkDesc
                            arr.createTime = aa[i].createTime
                            arr.productCode = aa[i].productCode
                            if(aa[i].checkPic != undefined && aa[i].checkPic != ''){
                                var pic = aa[i].checkPic.split(',')
                                for (let j = 0; j < pic.length; j++) {
                                    arr.checkPic.push(pic[j])
                                }
                            }
                            self.logList.push(arr)
                        }
                    }
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.upload-files {
    width: 300px;
}
.bottomBtn {
    width: 100%;
    height: 8vh;
    padding: 1.5vh 0;
    background-color: white;
    // border-top: 1px solid #c4c4c4;
}
</style>
